module.exports = __webpack_public_path__ + "res/24-img_button_bg.df0fbfef0c5efdbb4c1625b0db4ac622.png";